<div class="invalid-background min-h-screen flex justify-center items-center">
    <div class="invalid-text-container">
        <ng-container *ngIf="$servicingAORPhone | async as phoneNumber">
            <p class="phone:text-3xl text-xl font-bold">{{renderProperResponse(response, phoneNumber)}}</p>
        </ng-container>
    </div>
</div>
